import axiosInstance from "../utils/ApiUtils/axiosInstance";

export type ExportServicePackTranslationForm = {
  translationId: number;
};

export const reExportServicePackTranslation = async (
  data: ExportServicePackTranslationForm
): Promise<number | null> => {
  const response = await axiosInstance.post<ApiResponse<number>>(
    `/api/translation/re-extract-service-pack-translation`,
    data
  );
  return response.data.data;
};
